<!-- T.32832 - Template para tracking administrativo con Leaflet Maps -->
<div class="container-fluid tracking-adm-container p-0">
  
  <!-- T.32832 - Header con estadísticas integradas -->
  <div class="tracking-header">
    <div class="header-title">
      <i class="fas fa-truck mr-2"></i>
      Tracking de Camiones
    </div>
    <div class="stats-container">
      <div class="stat-card stat-total">
        <div class="stat-left">
          <div class="stat-content">
            <div class="stat-number">{{ viajesCreado.length + viajesEnCola.length + viajesEnRuta.length + viajesRevisionHabilitada.length }}</div>
            <div class="stat-percentage">(100%)</div>
          </div>
          <div class="stat-label">Viajes Totales</div>
        </div>
        <div class="stat-icon">
          <i class="fas fa-truck"></i>
        </div>
      </div>
      <div class="stat-card stat-habilitada">
        <div class="stat-left">
          <div class="stat-content">
            <div class="stat-number">{{ viajesRevisionHabilitada.length }}</div>
            <div class="stat-percentage">({{ getPorcentajeRevisionHabilitada() }}%)</div>
          </div>
          <div class="stat-label">Habil. Ingreso</div>
        </div>
        <div class="stat-icon">
          <i class="fas fa-check-circle"></i>
        </div>
      </div>
      <div class="stat-card stat-cola">
        <div class="stat-left">
          <div class="stat-content">
            <div class="stat-number">{{ viajesEnCola.length }}</div>
            <div class="stat-percentage">({{ getPorcentajeEnCola() }}%)</div>
          </div>
          <div class="stat-label">En Cola</div>
        </div>
        <div class="stat-icon">
          <i class="fas fa-clock"></i>
        </div>
      </div>
      <div class="stat-card stat-route">
        <div class="stat-left">
          <div class="stat-content">
            <div class="stat-number">{{ viajesEnRuta.length }}</div>
            <div class="stat-percentage">({{ getPorcentajeEnRuta() }}%)</div>
          </div>
          <div class="stat-label">En Ruta</div>
        </div>
        <div class="stat-icon">
          <i class="fas fa-route"></i>
        </div>
      </div>
      <div class="stat-card stat-creado">
        <div class="stat-left">
          <div class="stat-content">
            <div class="stat-number">{{ viajesCreado.length }}</div>
            <div class="stat-percentage">({{ getPorcentajeCreado() }}%)</div>
          </div>
          <div class="stat-label">Creado</div>
        </div>
        <div class="stat-icon">
          <i class="fas fa-file-alt"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- T.32832 - Sección del mapa -->
  <div class="mapa-section">
    <!-- T.32832 - Loader mientras carga el mapa -->
    <div *ngIf="loading" class="mapa-loader">
      <div class="text-center">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Cargando mapa...</span>
        </div>
        <p class="mt-2">Cargando datos de tracking...</p>
      </div>
    </div>

    <!-- T.32832 - Contenedor del mapa -->
    <div id="mapa-tracking" class="mapa-container"></div>
  </div>

  <!-- T.32832 - Panel de información de camiones -->
  <div class="info-panel">
    <div class="info-header">
      <i class="fas fa-info-circle mr-2"></i>
      Información de Viajes Planificados
      <span class="total-count">Total: {{ viajesCreado.length + viajesEnCola.length + viajesEnRuta.length + viajesRevisionHabilitada.length }} viajes</span>
    </div>
    
    <!-- T.32832 - Tabs para filtrar por estado -->
    <div class="tabs-container">
      <div class="tabs-header">
        <button 
          class="tab-button" 
          [class.active]="tabActiva === 'REVISION_HABILITADA'"
          (click)="cambiarTab('REVISION_HABILITADA')">
          <i class="fas fa-check-circle mr-1"></i>
          Ingreso Habilitado ({{ viajesRevisionHabilitada.length }})
        </button>
        <button 
          class="tab-button" 
          [class.active]="tabActiva === 'EN_COLA'"
          (click)="cambiarTab('EN_COLA')">
          <i class="fas fa-clock mr-1"></i>
          En Cola ({{ viajesEnCola.length }})
        </button>
        <button 
          class="tab-button" 
          [class.active]="tabActiva === 'EN_RUTA'"
          (click)="cambiarTab('EN_RUTA')">
          <i class="fas fa-route mr-1"></i>
          En Ruta ({{ viajesEnRuta.length }})
        </button>
        <button 
          class="tab-button" 
          [class.active]="tabActiva === 'CREADO'"
          (click)="cambiarTab('CREADO')">
          <i class="fas fa-file-alt mr-1"></i>
          Creado ({{ viajesCreado.length }})
        </button>
      </div>
      
      <div class="tabs-content">
        <!-- T.32832 - Tab CREADO -->
        <div *ngIf="tabActiva === 'CREADO'" class="tab-panel">
          <div class="viajes-grid-section-full">
            <!-- T.32832 - Loader mientras cargan los datos -->
            <div *ngIf="loadingViajes" class="text-center p-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="sr-only">Cargando viajes...</span>
              </div>
              <p class="mt-2 mb-0 small">Cargando viajes creados...</p>
            </div>

            <!-- T.32832 - Grid de viajes CREADO -->
            <div *ngIf="!loadingViajes && viajesCreado.length > 0" class="viajes-grid-container-full">
              <ag-grid-angular
                #agGridViajesCreado
                class="ag-theme-alpine"
                [rowData]="viajesCreado"
                [columnDefs]="columnDefsViajesCreado"
                [defaultColDef]="defaultColDefViajes"
                [rowHeight]="35"
                [domLayout]="'autoHeight'"
                [suppressHorizontalScroll]="false"
                (gridReady)="onGridViajesCreadoReady($event)">
              </ag-grid-angular>
            </div>

            <!-- T.32832 - Mensaje cuando no hay datos -->
            <div *ngIf="!loadingViajes && viajesCreado.length === 0" class="text-center p-3">
              <i class="fas fa-file-alt fa-2x text-muted mb-2"></i>
              <p class="text-muted small">No hay viajes creados</p>
            </div>
          </div>
        </div>
        
        <!-- T.32832 - Tab EN_COLA -->
        <div *ngIf="tabActiva === 'EN_COLA'" class="tab-panel">
          <div class="viajes-grid-section-full">
            <!-- T.32832 - Loader mientras cargan los datos -->
            <div *ngIf="loadingViajes" class="text-center p-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="sr-only">Cargando viajes...</span>
              </div>
              <p class="mt-2 mb-0 small">Cargando viajes en cola...</p>
            </div>

            <!-- T.32832 - Grid de viajes EN_COLA con flechas -->
            <div *ngIf="!loadingViajes && viajesEnCola.length > 0" class="viajes-grid-container-full">
              <ag-grid-angular
                #agGridViajesEnCola
                class="ag-theme-alpine"
                [rowData]="viajesEnCola"
                [columnDefs]="columnDefsViajesEnCola"
                [defaultColDef]="defaultColDefViajes"
                [rowHeight]="35"
                [domLayout]="'autoHeight'"
                [suppressHorizontalScroll]="false"
                (gridReady)="onGridViajesEnColaReady($event)">
              </ag-grid-angular>
            </div>

            <!-- T.32832 - Mensaje cuando no hay datos -->
            <div *ngIf="!loadingViajes && viajesEnCola.length === 0" class="text-center p-3">
              <i class="fas fa-clipboard-list fa-2x text-muted mb-2"></i>
              <p class="text-muted small">No hay viajes en cola</p>
            </div>
          </div>
        </div>
        
        <!-- T.32832 - Tab REVISION_HABILITADA -->
        <div *ngIf="tabActiva === 'REVISION_HABILITADA'" class="tab-panel">
          <div class="viajes-grid-section-full">
            <!-- T.32832 - Loader mientras cargan los datos -->
            <div *ngIf="loadingViajes" class="text-center p-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="sr-only">Cargando viajes...</span>
              </div>
              <p class="mt-2 mb-0 small">Cargando viajes habilitados...</p>
            </div>

            <!-- T.32832 - Grid de viajes REVISION_HABILITADA sin flechas -->
            <div *ngIf="!loadingViajes && viajesRevisionHabilitada.length > 0" class="viajes-grid-container-full">
              <ag-grid-angular
                #agGridViajesRevisionHabilitada
                class="ag-theme-alpine"
                [rowData]="viajesRevisionHabilitada"
                [columnDefs]="columnDefsViajesRevisionHabilitada"
                [defaultColDef]="defaultColDefViajes"
                [rowHeight]="35"
                [domLayout]="'autoHeight'"
                [suppressHorizontalScroll]="false"
                (gridReady)="onGridViajesRevisionHabilitadaReady($event)">
              </ag-grid-angular>
            </div>

            <!-- T.32832 - Mensaje cuando no hay datos -->
            <div *ngIf="!loadingViajes && viajesRevisionHabilitada.length === 0" class="text-center p-3">
              <i class="fas fa-check-circle fa-2x text-muted mb-2"></i>
              <p class="text-muted small">No hay viajes con revisión habilitada</p>
            </div>
          </div>
        </div>
        
        <!-- T.32832 - Tab EN_RUTA -->
        <div *ngIf="tabActiva === 'EN_RUTA'" class="tab-panel">
          <div class="viajes-grid-section-full">
            <!-- T.32832 - Loader mientras cargan los datos -->
            <div *ngIf="loadingViajes" class="text-center p-3">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="sr-only">Cargando viajes...</span>
              </div>
              <p class="mt-2 mb-0 small">Cargando viajes en ruta...</p>
            </div>

            <!-- T.32832 - Grid de viajes EN_RUTA sin flechas -->
            <div *ngIf="!loadingViajes && viajesEnRuta.length > 0" class="viajes-grid-container-full">
              <ag-grid-angular
                #agGridViajesEnRuta
                class="ag-theme-alpine"
                [rowData]="viajesEnRuta"
                [columnDefs]="columnDefsViajesEnRuta"
                [defaultColDef]="defaultColDefViajes"
                [rowHeight]="35"
                [domLayout]="'autoHeight'"
                [suppressHorizontalScroll]="false"
                (gridReady)="onGridViajesEnRutaReady($event)">
              </ag-grid-angular>
            </div>

            <!-- T.32832 - Mensaje cuando no hay datos -->
            <div *ngIf="!loadingViajes && viajesEnRuta.length === 0" class="text-center p-3">
              <i class="fas fa-route fa-2x text-muted mb-2"></i>
              <p class="text-muted small">No hay viajes en ruta</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- T.32832 - Detalles del camión (ahora fuera del panel) -->
<div class="camion-details-hidden" style="display: none;">
  <h6 class="details-title">Detalles del Camión</h6>
  
  <div *ngIf="camionSeleccionado" class="details-content">
    <div class="detail-header">
      <div class="detail-placa">{{ camionSeleccionado.placa }}</div>
      <span class="detail-status" [ngClass]="camionSeleccionado.enGeofence ? 'en-garita' : 'en-ruta'">
        {{ getTextoEstado(camionSeleccionado) }}
      </span>
    </div>
    
    <div class="detail-item">
      <strong>Chofer:</strong>
      <span>{{ camionSeleccionado.chofer }}</span>
    </div>
    
    <div class="detail-item" *ngIf="camionSeleccionado.cedula">
      <strong>Cédula:</strong>
      <span>{{ camionSeleccionado.cedula }}</span>
    </div>
    
    <div class="detail-item">
      <strong>Estado:</strong>
      <span>{{ camionSeleccionado.enGeofence ? 'En garita' : 'En ruta' }}</span>
    </div>
    
    <div class="detail-item">
      <strong>Distancia:</strong>
      <span>{{ camionSeleccionado.distanciaGarita.toFixed(0) }}m</span>
    </div>
  </div>

  <div *ngIf="!camionSeleccionado" class="no-selection">
    <i class="fas fa-mouse-pointer fa-2x text-muted mb-2"></i>
    <p class="text-muted small">Selecciona un camión para ver sus detalles</p>
  </div>
</div>
